<template>
   <div>
      <HeaderInnerPage
         id="how-works"
         title="Olá, somos a Pedale!"
         :background="bgPage"
      >Sua plataforma exclusiva de aluguel de bicicletas no Brasil.<br>Simplificamos o acesso às bicicletas em várias
         cidades com apenas alguns toques. <br>Está esperando o que pra pedalar? Vai de bike! Vai com a Pedale!<br>Descubra
         a Pedale - Sua Passagem para Aventuras Sustentáveis!<br>
         <el-link
            :underline="false"
            @click="$router.push(`/como-funciona-a-pedale`)"
            size=""
            class="bg-primary font-weight-bold text-white d-inline-block rounded pt-3 pb-3 pl-5 pr-5 mt-4"
            round>
            COMO FUNCIONA
         </el-link>
      </HeaderInnerPage>

      <section>
         <b-container>

            <b-row class="mt-0 mt-lg-3 text-center text-lg-left">
               <b-col lg="5">
                  <p class="lead"><strong>Explore. Conecte. Pedale.</strong> Seu portal para a mobilidade sustentável. Desbloqueie uma
                     experiência incomparável a cada pedalada, onde a cidade é sua e a natureza é sua aliada.</p>

                  <p class="lead"><strong>Conectando Cidades. Elevando Estilos de Vida.</strong> Nossa jornada começou com um sonho
                     simples: tornar a emoção de pedalar acessível a todos. Com nossa plataforma intuitiva e segura,
                     facilitamos o compartilhamento de bicicletas por todo o país, proporcionando um estilo de vida
                     ativo e saudável.
                  </p>

                  <p class="lead"><strong>Desbloqueie Novas Aventuras. Desperte Novas Oportunidades.</strong> A Pedale abre as portas
                     para uma rede de experiências e empreendimentos. Pedale pelas ruas e descubra novas conexões - com
                     a cidade, com a natureza e com novas possibilidades. É a ferramenta para cidades inteligentes!</p>

                  <p class="lead"><strong>Mobilidade Sustentável, Conduzida por Você.</strong> Acreditamos na magia de uma simples
                     pedalada. Sinta a pulsação da cidade ao seu redor, respire a liberdade da natureza e celebre a
                     simplicidade da vida. Vamos juntos desbravar novos horizontes. Pedale é liberdade!</p>

                  <p class="lead"><strong>Pedale Agora!</strong> Junte-se a nós nesta jornada emocionante. Abra as portas para um novo
                     mundo de possibilidades de locomoção.
                     Vá de bike! Vá com a Pedale!</p>
                  <div>

                     <button
                        @click="() => this.$router.push({name: 'search', params: { options: 'new' } })"
                        class="el-button text-uppercase bg-primary font-weight-bold el-button--primary is-round mt-4">
                        E então, onde vamos pedalar?
                     </button>
                  </div>
                  <div class="mt-4 ml-0 ml-lg-3">
                     <router-link to="/registrar">Quero alugar a minha bicicleta →</router-link>
                  </div>
               </b-col>
               <b-col lg="7" class="mt-5 mt-lg-3">
                  <img class="img-fluid" :src="idealImg" alt="Icone"/>
               </b-col>
            </b-row>
         </b-container>
      </section>
   </div>

</template>

<script>
// @ is an alias to /src
import bgPage from '@/assets/img/sobre-o-pedale.jpg';
import idealImg from '@/assets/img/um-ideal-para-compartilhar-bicicletas.svg';
import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
import {metaTags} from "@/helpers";

export default {
   name: 'about',
   metaInfo: metaTags(`Sobre`, `Aluguel de bicicletas, através da interação direta entre o dono da bike e quem deseja pedalar.
Parece fácil né? E é, conheça a Pedale!`),
   components: {
      HeaderInnerPage
   },
   data() {
      return {
         bgPage,
         idealImg
      }
   }
}
</script>
